import i18next from 'i18next'

function getReviewColumn() {
  return {
    id: 'review',
    title: i18next.t('column_selector.review'),
    subColumns: [
      {
        id: 'impact_start_date',
        title: i18next.t('column_selector.impact_start_date'),
      },
      {
        id: 'impact_end_date',
        title: i18next.t('column_selector.impact_end_date'),
      },
      {
        id: 'financial_validation_date',
        title: i18next.t('column_selector.financial_validation_date'),
      },
      {
        id: 'total_impact_amount',
        title: i18next.t('column_selector.total_impact_amount'),
      },
    ],
  }
}
function getRevCommonColumns() {
  return [
    {
      id: 'contentType',
      title: i18next.t('common.content_type'),
    },
    {
      id: 'title',
      title: i18next.t('column_selector.title'),
    },
    {
      id: 'link',
      title: i18next.t('column_selector.link_to_content'),
    },
    {
      id: 'status',
      title: i18next.t('column_selector.status'),
    },
    {
      id: 'validations',
      title: i18next.t('column_selector.validation_other'),
    },
    {
      id: 'location',
      title: i18next.t('common.location'),
      subColumns: [
        {
          id: 'site',
          title: i18next.t('column_selector.site_one'),
        },
        {
          id: 'country',
          title: i18next.t('column_selector.country_one'),
        },
        {
          id: 'siteGroups',
          title: i18next.t('column_selector.site_group_other'),
        },
      ],
    },
    {
      id: 'tags',
      title: i18next.t('column_selector.tag_other'),
    },
    {
      id: 'categories',
      title: i18next.t('column_selector.category_other'),
    },
    {
      id: 'createdAt',
      title: i18next.t('column_selector.created_date'),
    },
    {
      id: 'completedAt',
      title: i18next.t('column_selector.completed_date'),
    },
    {
      id: 'owner',
      title: i18next.t('column_selector.owner'),
    },
    {
      id: 'coach',
      title: i18next.t('column_selector.coach'),
    },
    {
      id: 'collaborators',
      title: i18next.t('column_selector.collaborator_other'),
    },
  ]
}
function getImprovementIdeaColumns() {
  return [
    ...getRevCommonColumns(),
    {
      id: 'phases',
      title: i18next.t('column_selector.phase_other'),
      subColumns: [
        {
          id: 'plan',
          title: i18next.t('column_selector.plan'),
          subColumns: [
            {
              id: 'problem',
              title: i18next.t('column_selector.problem'),
            },
          ],
        },

        {
          id: 'adjust',
          title: i18next.t('column_selector.adjust'),
          subColumns: [
            {
              id: 'solution',
              title: i18next.t('column_selector.solution'),
            },
          ],
        },
        getReviewColumn(),
      ],
    },
  ]
}
function getQuickActionColumns() {
  return [
    ...getRevCommonColumns(),
    {
      id: 'phases',
      title: i18next.t('column_selector.phase_other'),
      subColumns: [
        {
          id: 'before',
          title: i18next.t('column_selector.before'),
          subColumns: [
            {
              id: 'problem',
              title: i18next.t('column_selector.problem'),
            },
          ],
        },

        {
          id: 'after',
          title: i18next.t('column_selector.after'),
          subColumns: [
            {
              id: 'action',
              title: i18next.t('column_selector.action'),
            },
            {
              id: 'problemSolver',
              title: i18next.t('column_selector.problem_solver'),
            },
          ],
        },
        getReviewColumn(),
      ],
    },
  ]
}
function getProblemSolvingColumns() {
  return [
    ...getRevCommonColumns(),
    {
      id: 'phases',
      title: i18next.t('column_selector.phase_other'),
      subColumns: [
        {
          id: 'define',
          title: i18next.t('column_selector.define'),
          subColumns: [
            {
              id: 'problem',
              title: i18next.t('column_selector.problem'),
            },
            {
              id: 'plan',
              title: i18next.t('column_selector.plan'),
            },
          ],
        },
        {
          id: 'improveControl',
          title: i18next.t('column_selector.improve_control'),
          subColumns: [
            {
              id: 'solution',
              title: i18next.t('column_selector.solution'),
            },
          ],
        },
        getReviewColumn(),
      ],
    },
  ]
}
function getFindingColumns() {
  return [
    {
      id: 'contentType',
      title: i18next.t('common.content_type'),
    },
    {
      id: 'title',
      title: i18next.t('column_selector.title'),
    },
    {
      id: 'link',
      title: i18next.t('column_selector.link_to_content'),
    },
    {
      id: 'priority',
      title: i18next.t('column_selector.priority'),
    },
    {
      id: 'status',
      title: i18next.t('column_selector.status'),
    },
    {
      id: 'createdAt',
      title: i18next.t('column_selector.created_date'),
    },
    {
      id: 'completedAt',
      title: i18next.t('column_selector.completed_date'),
    },
    {
      id: 'assignees',
      title: i18next.t('column_selector.assignee_other'),
    },
    {
      id: 'categories',
      title: i18next.t('column_selector.category_other'),
    },
    {
      id: 'routine',
      title: i18next.t('column_selector.routine_one'),
    },
    {
      id: 'location',
      title: i18next.t('column_selector.location'),
      subColumns: [
        {
          id: 'site',
          title: i18next.t('column_selector.site_one'),
        },
        {
          id: 'country',
          title: i18next.t('column_selector.country_one'),
        },
        {
          id: 'siteGroups',
          title: i18next.t('column_selector.site_group_other'),
        },
      ],
    },
    {
      id: 'tags',
      title: i18next.t('column_selector.tag_other'),
    },
  ]
}
function getRoutineColumns() {
  return [
    {
      id: 'contentType',
      title: i18next.t('common.content_type'),
    },
    {
      id: 'title',
      title: i18next.t('column_selector.title'),
    },
    {
      id: 'link',
      title: i18next.t('column_selector.link_to_content'),
    },
    {
      id: 'status',
      title: i18next.t('column_selector.status'),
    },
    {
      id: 'location',
      title: i18next.t('common.location'),
      subColumns: [
        {
          id: 'site',
          title: i18next.t('column_selector.site_one'),
        },
        {
          id: 'country',
          title: i18next.t('column_selector.country_one'),
        },
        {
          id: 'siteGroups',
          title: i18next.t('column_selector.site_group_other'),
        },
      ],
    },
    {
      id: 'tags',
      title: i18next.t('column_selector.tag_other'),
    },
    {
      id: 'executedBy',
      title: i18next.t('column_selector.executed_by'),
    },
    {
      id: 'description',
      title: i18next.t('column_selector.description'),
    },
    {
      id: 'executedAt',
      title: i18next.t('column_selector.executed_date'),
    },
    {
      id: 'completedAt',
      title: i18next.t('column_selector.completed_date'),
    },
  ]
}
export default {
  getImprovementIdeaColumns,
  getQuickActionColumns,
  getProblemSolvingColumns,
  getRoutineColumns,
  getFindingColumns,
}
